import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from 'react-apexcharts';

class PendingReq extends Component {

  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: 'Pedidos pendentes',
        align: 'center',
        margin: 40,
        style: {
          fontSize:  '14px',
          fontWeight:  'bold',
          color:  '#263238'
        }
      },
      labels: [
        'Desde sempre', 
        'Período de tempo:'
      ],
      legend: {
        show: true,
        position: "bottom",
        fontSize: '13px'
      },
     colors:['#008080', '#4169E1']
    }
  }

  render() {

    return (
      <div>
        {this.props.pendingReq && (
        <Chart 
          title={this.state.title}
          options={this.state.chartOptions} 
          series={[this.props.pendingReq[0].pendentes_dsd_sp, 
                   this.props.pendingReq[0].pendentes_ultimos_30_dias]}
          type="pie" 
          width="480"
          style={{marginTop:-120, marginLeft:10}}
        /> 
        )}
        {this.props.filter_slider && this.props.filter_slider != null ?
          <div class="label_slider2_dates">definido no filtro</div> : <div class="label_slider2_predef">últimos 30 dias </div>
        }
      </div>
    );
  }
}
export default PendingReq;
